import {mapGetters} from "vuex";

const jobKeyFilter = [
    'amount', 'amountProduced', 'companyId', 'downTimeIds', 'reasonTreeRequired', 'timeSpent', 'reasonTreeRequired',
    'id', 'updated_at', 'comment', 'plannedDate', 'originalPlannedDate', 'finishedDate',
    'downTimeTotal', 'downTimeTotalPlanned', 'uid', 'predictedGrossTimeSpent', 'predictedNetTimeSpent','userNameList','target']

const downTimeKeyFilter = [
    'amount', 'amountProduced', 'companyId', 'downTimeIds', 'reasonTreeRequired', 'timeSpent', 'reasonTreeRequired',
    'id', 'updated_at', 'comment', 'job', 'jobId', 'normInMs', 'productionRunId', 'productionStart', 'productionEnd',
    'downTimeEnded', 'downTimeIndicator', 'reason', 'target', 'userId', 'uid', 'downTimeRunning',
    'averageDownTimeForReason', 'predictedNetTimeSpent', 'idempotencyKey']

export default {
    props: ['savedConfig'],
    computed: {
        ...mapGetters('workflows', ['getWorkflowName']),
        getComponentConfig() {
            return {
                ...this.savedConfig
            }
        },
        generalChartOptions() {
            return {
                animation: {
                    duration: 0 // general animation time
                },
                hover: {
                    animationDuration: 0 // duration of animations when hovering an item
                },
                legend: {
                    position: 'top',
                    align: 'end',
                },
                layout: {
                    padding: {
                        left: 20,
                        right: 20,
                        top: 0,
                        bottom: 0
                    }
                },

                title: this.getChartTitle,
            }
        },
        getChartTitle() {
            let title = this.savedConfig && this.savedConfig.title ? this.savedConfig.title : ''
            title = this.config && this.config.title ? this.config.title : ''
            if (this.config && this.config.title) {
                title = this.config.title
            }
            return {
                display: true,
                text: title,
                fontSize: 18,
                fontStyle: 'normal',
                position: 'bottom',
            }
        }
    },
    methods: {
        getFormattedKey(key) {
            if (key === 'workflowId' || key == 'workflowList') {
                return this.$root.$t('workflows.name')
            }
            if (key === 'department') {
                return this.$root.$t('departments.name')
            }
            if (_.includes(['userName', 'orderNumber','activity','status','finishedBy'], key)) {
                return this.$root.$t('insights.filters.keys.' + key)
            }
            return key
        },
        getFormattedValue(value) {
            if (this.config.filterByKey === 'workflowList' || this.config.filterByKey === 'workflowId') {

                return this.getWorkflowName(value)
            }
            return value
        },
        getUniqueJobKeys() {
            let uniqueKeys = []

            if (this.getJobs) {
                uniqueKeys = Object.keys(Object.assign({}, _.omit(...this.getJobs, jobKeyFilter)
                ))
            }
            return this.filterAvailableKeys(this.getJobs, uniqueKeys)

        },
        filterAvailableKeys(data, keys) {
            let keysWithValue = []
            _.each(keys, key => {
                let count = _.filter(data, d => {
                    if (d[key] !== null) {
                        return key
                    }
                })

                if (count.length)
                    keysWithValue.push(key)
            })
            return keysWithValue.sort()
        },
        getUniqueDownTimeKeys() {
            let uniqueKeys = Object.keys(Object.assign({}, _.omit(...this.getDownTimes, downTimeKeyFilter)
            ))

            return this.filterAvailableKeys(this.getDownTimes, uniqueKeys)
        },
        emitConfig() {
             this.$emit('configChanged', this.config)
        }
    },
    watch: {
        config: {
            handler: function (newV, oldV) {
                 this.emitConfig()
            },
            deep: true
        },
        savedConfig: {
            handler: function (newV) {
                this.config = newV
                this.savedConfig = newV
            },
            deep: true
        },
    },
    created() {
        this.config = this.getComponentConfig
    }
}